import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../../libraries/libraries.module';
import { SharedModule } from '../../../libraries/shared.module';
import { RegionDealerListComponent } from './list-region-dealer/region-dealer-list.component';
import { ProductRestService } from '../product-rest.service';
import { RegionDealerRoutingModule } from './region-dealer-routing.module';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

export const PROVIDERS = [ProductRestService];

@NgModule({
  imports: [
    RegionDealerRoutingModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule,
    DialogModule,
    ButtonModule
  ],
  declarations: [
    RegionDealerListComponent,
  ]
})
export class RegionDealerModule {}
